var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar-alert",class:_vm.type},[_c('span',[_vm._t("title",function(){return [_c('b',[_vm._v(_vm._s(_vm.title))])]}),_vm._t("description",function(){return [_vm._v(" "+_vm._s(_vm.description)+" ")]}),_vm._t("cta")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }